// @flow
import styled from 'styled-components';
import {
  textNormal,
  textBlack,
  textBold,
  textBoldLoose,
  textSemiBold,
} from './css';
import { Text4 } from './Text';

export const Text4Normal = styled(Text4)`
  ${textNormal};
`;

export const Text4Black = styled(Text4)`
  ${textBlack};
`;

export const Text4Bold = styled(Text4)`
  ${textBold};
`;

export const Text4SemiBold = styled(Text4)`
  ${textSemiBold};
`;

export const Text4BoldLoose = styled(Text4)`
  ${textBoldLoose};
`;
